var React = require('react');

function Medium (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-medium-m","data-name":"Icon awesome-medium-m","d":"M5.508,10.663a1.486,1.486,0,0,0-.48-1.244L1.479,5.138V4.5H12.513l8.532,18.709L28.546,4.5H39.069v.638L36.031,8.05a.886.886,0,0,0-.338.85V30.308a.886.886,0,0,0,.338.85L39,34.07v.638H24.067V34.07l3.077-2.983c.3-.3.3-.394.3-.85v-17.3L18.888,34.652H17.731L7.783,12.937V27.49a1.982,1.982,0,0,0,.551,1.669l4,4.848v.638H1v-.63l4-4.856a1.918,1.918,0,0,0,.512-1.669Z","transform":"translate(-0.998 -4.5)","fill":"#fff"}));
}

Medium.defaultProps = {"id":"medium_icon","data-name":"medium icon","width":"38.07","height":"30.208","viewBox":"0 0 38.07 30.208"};

module.exports = Medium;

Medium.default = Medium;
